import { render, staticRenderFns } from "./DrillScoring.vue?vue&type=template&id=ee97a206&scoped=true&lang=pug&"
import script from "./DrillScoring.vue?vue&type=script&lang=ts&"
export * from "./DrillScoring.vue?vue&type=script&lang=ts&"
import style0 from "./DrillScoring.vue?vue&type=style&index=0&id=ee97a206&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ee97a206",
  null
  
)

export default component.exports